import React from "react";
import "./TicketStatsCard.css";
import { IoTicketSharp } from "react-icons/io5";
import { FaDownload } from "react-icons/fa";
import { GiSaloonDoors } from "react-icons/gi";

//RED
// #DC3535
//Green
// #006400
//Blue
// #2F58CD

const TicketStatsCard = ({
  reduceToBePaidCount = 0,
  paidReduceCount = 0,
  fullToBePaidCount = 0,
  paidFullCount = 0,
  compCount = 0,
  prepaidCount = 0,
  paidReduceRevenue = 0,
  paidFullRevenue = 0,
  prepaidRevenue = 0,
  totalRevenue = 0,
  onDownloadPressed,
  isDownloading = false
}) => {
  const statsRowOne = [
    {
      label: 'Reduce',
      value: reduceToBePaidCount,
      type: 'REDUCE',
      icon: <GiSaloonDoors color="#DC3535" />
    },

    {
      label: 'Full',
      value: fullToBePaidCount,
      type: 'FULL',
      icon: <GiSaloonDoors color="#2F58CD" />
    },

    {
      label: 'Comp',
      value: compCount,
      type: 'COMP',
      icon: <IoTicketSharp color="#006400" />
    }
  ];
  const statsRowTwo = [
    {
      label: 'Paid Reduce',
      value: paidReduceCount,
      type: 'PAID_REDUCE',
      icon: <IoTicketSharp color="#DC3535" />
    },

    {
      label: 'Paid Full',
      value: paidFullCount,
      type: 'FULL',
      icon: <IoTicketSharp color="#2F58CD" />
    },
    {
      label: 'Prepaid',
      value: prepaidCount,
      type: 'PREPAID',
      icon: <IoTicketSharp color="black" />
    }
  ];

  const statsRevenue = [
    {
      label: 'Paid Reduce',
      value: `$${paidReduceRevenue}`,
      type: 'REDUCE'
    },
    {
      label: 'Paid Full',
      value: `$${paidFullRevenue}`,
      type: 'FULL'
    },
    {
      label: 'Prepaid',
      value: `$${prepaidRevenue}`,
      type: 'PREPAID'
    },
    {
      label: 'Total',
      value: `$${totalRevenue}`,
      type: 'TOTAL'
    }
  ];

  return (
    <div className="main-container">
      <div className="stats-header">
        <h3 className="stats-heading">{'Tickets Sold'}</h3>
        <button
          className="download-btn"
          onClick={onDownloadPressed}
          disabled={isDownloading}
        >
          {isDownloading ? (
            <span className="spinner-big" />
          ) : (
            <FaDownload style={{marginRight: '8px'}} />
          )}
          {isDownloading ? 'Creating Report' : 'Download Report'}
        </button>
      </div>
      <div className="stats-container">
        {statsRowOne.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-value-wrapper">
              <span className="stat-value">{stat.value}</span>
              <span className="stat-icon">{stat.icon}</span>
            </div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>

      <div className="stats-container">
        {statsRowTwo.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-value-wrapper">
              <span className="stat-value">{stat.value}</span>
              <span className="stat-icon">{stat.icon}</span>
            </div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>

      <h3 className="stats-heading">{'Total Revenue'}</h3>
      <div className="stats-container">
        {statsRevenue.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-value-wrapper">
              <span className="stat-value">{stat.value}</span>
              <span className="stat-icon">{stat.icon}</span>
            </div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TicketStatsCard;
